import { defineMessages } from 'react-intl';

const translations = {
  headers: {
    location: {
      id: 'productInventoryTable.headers.location',
      defaultMessage: 'Location',
      description: 'Label of the location header',
    },
    available: {
      id: 'productInventoryTable.headers.available',
      defaultMessage: 'Available',
      description: 'Label of the available header',
    },
  },
  emptyMessage: {
    id: 'productInventoryTable.emptyMessage',
    defaultMessage: 'No stock available',
    description: 'Empty message of the product inventory table',
  },
};

export default defineMessages(translations);
